module.exports = __webpack_public_path__ + "img/icon_tab_favorite.018d2b51.png";